<template>
  <div style="overflow: auto;">
    <a-card hoverable :bordered="false">
      <a-row type="flex">
        <a-col style="margin-right:20px" >
          <span>审核人：</span>
          <a-select style="width:200px" allowClear v-model="audit_admin_id">
            <a-select-option v-for="item in userList" :key="item.id" :value="item.id"> {{item.name}} </a-select-option>
          </a-select>
        </a-col>
        <a-button @click="getData" type="primary"> 搜索 </a-button>
      </a-row>
    </a-card>
    <a-card
      style="margin-top: 16px; overflow: auto"
      hoverable
      :bordered="false"
    >
      <a-tabs default-active-key="0" @change="tabChange">
        <a-tab-pane key="0" :tab="'全部'"></a-tab-pane><!-- ('+allCount+') -->
        <a-tab-pane
          key="2"
          :tab="'未逾期'"
          force-render
        ></a-tab-pane><!-- ('+awaitCount+') -->
        <a-tab-pane
          key="1"
          :tab="'已逾期'"
        ></a-tab-pane><!-- ('+overdueCount+') -->
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :scroll="{ y: tableH - 150 }"
      >
      <span slot="id" slot-scope="text, record,index">
          {{pagination.pageSize*(pagination.current-1) + index + 1}}
        </span>
      <span slot="handle" class="red" v-if="record.overdue" slot-scope="text, record">
        已逾期
      </span>
      <span slot="handle" v-else slot-scope="text, record">
        未逾期
      </span>
      </a-table>

    </a-card>

    <a-modal :visible="logModal" :footer="null" @cancel="logModal = false">
      <a-timeline mode="alternate" style="padding-top: 30px">
        <a-timeline-item>Create a services site 2015-09-01</a-timeline-item>
        <a-timeline-item color="green">
          Solve initial network problems 2015-09-01
        </a-timeline-item>
        <a-timeline-item color="red">
          机构未通过 2021-08-19 17:49:16
        </a-timeline-item>
        <a-timeline-item color="green">报审通过 2015-09-01</a-timeline-item>
        <a-timeline-item> 开始审核 2021-08-19 17:49:16 </a-timeline-item>
      </a-timeline>
    </a-modal>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {task_overview} from '@/api/organization'
import {user_list} from "@/api/user_manage";

const plainOptions = ["全部", "已逾期", "未逾期"];
const options = [
  { label: "全部", value: "全部" },
  { label: "已逾期", value: "已逾期" },
  { label: "未逾期", value: "未逾期" }
];

const columns = [
  {
    title: "序号",
    dataIndex: "id",
    align: "center",
    scopedSlots: { customRender: "id" },
  },
  {
    title: "审核人",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "累计任务数",
    dataIndex: "total",
    align: "center",
  },
  {
    title: "分配任务数",
    dataIndex: "allot",
    align: "center",
  },
  {
    title: "待处理数",
    dataIndex: "no_finish",
    align: "center",
  },
  {
    title: "已处理数",
    dataIndex: "finish",
    align: "center",
  },
  {
    title: "逾期数",
    dataIndex: "overdue",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "handle",
    align: "center",
    scopedSlots: { customRender: "handle" },
  },
];

const data = [];
export default {
  data() {
    return {
      plainOptions,
      options,
      value1: "Apple",
      locale,
      moment,
      currentPageData: [],
      tableH: "", //表格容器高度
      columns, //表格抬头
      data, //表格数据
      pagination: {
        //表格分页
        current: 1,
        total: 0,
        pageSize: 20, //每页中显示10条数据
        showSizeChanger: true,
        showLessItems: true,
        // hideOnSinglePage: true,
        pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
        onChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
        onShowSizeChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);

          this.getData(this.status);
        },
      },
      status:"",
      audit_admin_id:"",
      logModal: false,
      userList:[],
      allCount:0,
      overdueCount:0,
      awaitCount:0,
    };
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.tableH = document.body.clientHeight - 200; //259
      // tableDom.style.height= this.tableH+"px" //表格滚动条预留
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.tableH = window.innerHeight - 200; //259
        // tableDom.style.height= this.tableH+"px" //表格滚动条预留
      })();
    };
  },
  created(){
    this.getData()
    this.getUser()
  },
  methods: {
    //获取审核人信息
    getUser(){
      user_list({
        page_size: 999,
        page_no: 1,
        name_phone: "",
        status: 1,
        roles: "0",
      }).then(res=>{
        if(res){
          this.userList = res.data
        }
      })
    },
    //获取表格数据
    getData(){
      let data = `id=${this.$store.state.user.id}&page_size=${this.pagination.pageSize}&page_no=${this.pagination.current}&is_overdue=${this.status}&admin_id=${this.audit_admin_id?this.audit_admin_id:''}`
      this.$store.commit("spinning", true);
      task_overview(data).then(res=>{
        if(res){
          console.log(res)
          this.data = res.data.data
          this.allCount = res.data.overdue_total + res.data.no_overdue_total
          this.overdueCount = res.data.overdue_total
          this.awaitCount = res.data.no_overdue_total
          /* res.data.data.map(item=>{
            if(item.overdue){
              this.overdueCount++
            }else{
              this.awaitCount++
            }
          }) */
          this.$store.commit("spinning", false);
        }else{
          this.$message.error(res.message)
          this.$store.commit("spinning", false);
        }
      }).catch(err=>{
        this.$store.commit("spinning", false);
      })
    },
    tabChange(type){
      if(type){
        this.status = type
      }else{
        this.status = 0
      }
      this.getData()
    },
  },
};
</script>

<style lang="less" scoped>
.ant-row,
.btns {
  height: 40px;
  line-height: 40px;
  .btns {
    display: flex;
    justify-content: space-between;
    .ant-btn {
      margin: auto 0;
    }
  }
}
</style>